import React, { Component } from 'react';
import { Dropdown, Input, Divider, Button, Checkbox } from 'semantic-ui-react';
import _ from 'lodash';

import './ModalCampaign.css';

class ModalCampaign extends Component {
  state = {
    selectedObjective: '',
    campaignName: '',
    tags: '',
    isHecCampaign: false
  };

  onObjectiveSelect = (event, { options, value }) => {
    const objective = _.find(options, (option) => {
      return option.value === value;
    });

    const selectedObjective = objective.value;
    this.setState((prevState) => ({ ...prevState, selectedObjective }));
  };

  handleFormChange = (event, { name, value }) => {
    this.setState((prevState) => ({ ...prevState, [name]: value }));
  };

  saveCampaign = () => {
    const { campaignName, selectedObjective, tags, isHecCampaign } = this.state;
    const { addCampaign } = this.props;
    const campaign = {
      name: campaignName,
      objective: selectedObjective,
      status: 'PAUSED',
      buying_type: 'AUCTION',
      tags,
      is_hec_campaign: isHecCampaign
    };
    if (addCampaign) {
      addCampaign(campaign);
    }
  };

  closeCampaignModal = () => {
    const { onCloseModalCampaign } = this.props;
    if (onCloseModalCampaign) {
      onCloseModalCampaign();
    }
  };

  handleFlagChange = () => {
    const { isHecCampaign } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      isHecCampaign: !isHecCampaign
    }));
  };

  render() {
    const { campaignName, selectedObjective, tags, isHecCampaign } = this.state;
    const { objectiveOptions } = this.props;
    return (
      <div className="modal-campaign-container">
        <Input
          placeholder="Campaign Name"
          type="text"
          name="campaignName"
          value={campaignName}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Objective"
          search
          selection
          id="objective"
          value={selectedObjective}
          options={objectiveOptions}
          onChange={this.onObjectiveSelect}
        />
        <Divider hidden />
        <Input
          placeholder="Tags"
          type="text"
          name="tags"
          value={tags}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Checkbox
          label="HEC Campaign"
          checked={isHecCampaign}
          onChange={this.handleFlagChange}
        />
        <Divider hidden />
        <Button onClick={this.closeCampaignModal} size="small" color="grey">
          Cancel
        </Button>
        <Button onClick={this.saveCampaign} size="small" color="blue">
          Save
        </Button>
      </div>
    );
  }
}

export default ModalCampaign;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ModalCampaign.js